import React, { useRef, useEffect } from "react";

const LightModeBubbles = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const bubbles = [];
    const numberOfBubbles = 50;

    // Initialize bubbles
    for (let i = 0; i < numberOfBubbles; i++) {
      bubbles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        radius: Math.random() * 20 + 10, // Random size
        speedX: (Math.random() - 0.5) * 2, // Horizontal speed
        speedY: (Math.random() - 0.5) * 2, // Vertical speed
        color: `rgba(${Math.random() * 255}, ${Math.random() * 255}, ${
          Math.random() * 255
        }, 0.5)`, // Soft pastel colors
      });
    }

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Draw gradient background
      const gradient = ctx.createLinearGradient(
        0,
        0,
        canvas.width,
        canvas.height
      );
      gradient.addColorStop(0, "#3a64fa");
      gradient.addColorStop(1, "#f963bc");
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Draw bubbles
      bubbles.forEach((bubble) => {
        ctx.beginPath();
        ctx.arc(bubble.x, bubble.y, bubble.radius, 0, Math.PI * 2);
        ctx.fillStyle = bubble.color;
        ctx.fill();
        ctx.closePath();

        // Update bubble position
        bubble.x += bubble.speedX;
        bubble.y += bubble.speedY;

        // Wrap around edges
        if (bubble.x - bubble.radius > canvas.width) bubble.x = -bubble.radius;
        if (bubble.x + bubble.radius < 0)
          bubble.x = canvas.width + bubble.radius;
        if (bubble.y - bubble.radius > canvas.height) bubble.y = -bubble.radius;
        if (bubble.y + bubble.radius < 0)
          bubble.y = canvas.height + bubble.radius;
      });

      requestAnimationFrame(animate);
    };

    animate();

    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
      }}
    />
  );
};

export default LightModeBubbles;
